import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useCookies } from 'react-cookie';
import Modal from '../Footer/ModalAdresses/ModalComponent';
import '../../styles/App.scss';
import './AgeConfirmModal.scss';
import { checkDomain } from '../../functions/checkDomain/checkDomain';

function AgeConfirmModal() {
  const [cookies, setCookie] = useCookies([]);

  // хуки для управления попапом
  const targetRef = React.createRef();
  const [showModal, setShowModal] = useState(false);
  const onShowModal = () => {
    setShowModal(true);
    disableBodyScroll(targetRef.current);
  };
  const onCloseModal = () => {
    setShowModal(false);
    enableBodyScroll(targetRef.current);
    setCookie(['ageConfirmed'], true, { domain: checkDomain() });
  };
  useEffect(() => {
    setTimeout(() => onShowModal());
  }, []);

  // хук для сообщения об отказе
  const [showDiscard, setShowDiscard] = useState(false);
  const openDiscardInfo = () => {
    setShowDiscard(true);
  };
  const closeDiscardInfo = () => {
    setShowDiscard(false);
  };

  // скрываем на странице скачивания приложения
  const { pathname } = useLocation();
  if (pathname === '/club-app' || pathname === '/en/club-app') return null;

  return (
    <>
      {!cookies.ageConfirmed && (
        <div className='age-confirm-modal'>
          <Modal targetRef={targetRef} showModal={showModal} setShowModal={setShowModal} maxWidth='427px'>
            <div className='age-confirm-box'>
              {!showDiscard && (
                <div className='age-confirm-front'>
                  <div className='age-confirm-title'>Вам уже есть 18 лет?</div>
                  <div className='age-confirm-text'>
                    Подтвердите, пожалуйста, что вы достигли совершеннолетия, чтобы продолжить пользоваться сайтом
                  </div>
                  <div className='age-confirm-btns'>
                    <button className='age-confirm-btn age-confirm-btn--accept' onClick={onCloseModal}>
                      Да, мне есть 18
                    </button>
                    <button className='age-confirm-btn age-confirm-btn--discard' onClick={openDiscardInfo}>
                      Нет
                    </button>
                  </div>
                </div>
              )}
              {showDiscard && (
                <div className='age-confirm-back'>
                  <div className='age-confirm-title'>Спасибо за честный ответ</div>
                  <div className='age-confirm-text'>
                    Мы заботимся о здоровье будущего поколения, поэтому не демонстрируем алкоголь лицам младше 18 лет.
                  </div>
                  <div className='age-confirm-btns'>
                    <button className='age-confirm-btn age-confirm-btn--accept' onClick={closeDiscardInfo}>
                      Назад
                    </button>
                  </div>
                </div>
              )}
            </div>
          </Modal>
        </div>
      )}
    </>
  );
}

export default AgeConfirmModal;
